import { Box, Typography } from "@avenue-8/sidekick-ui";
import { InsightsSectionView } from "@cma/presentation-generation-logic";
import styled from "@emotion/styled";
import { useMemo } from "react";
import { PresentationSectionViewProps } from "../PresentationSectionProps";
import { PrintPaper, PrintPage } from "../../shared/Print.styles";

interface Props extends PresentationSectionViewProps<InsightsSectionView> {}

const PrintInsightsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  gap: 1.5rem;
  width: 100%;
  height: 100%;
  padding: 0 1.5rem;
  place-items: center;
  margin-top: 1rem;
`;

const PrintInsightItem = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
  background-color: ${(p) => p.theme.colors.background2};
  border-radius: 0.5rem;
  min-height: 250px;
  height: 100%;
  flex: 0 0 calc(33.333% - 1rem);
  width: 100%;
`;

export const InsightsPrint = (props: Props) => {
  const { sectionView } = props;
  const { id, insights } = sectionView;

  const insightsToDisplay = useMemo(() => {
    return insights?.filter((x) => x.mode === "ok") || [];
  }, [insights]);

  if (insightsToDisplay.length === 0) {
    return null;
  }

  return (
    <>
      <PrintPaper>
        <PrintPage id={id}>
          <Typography variant="h5" mb={2} textAlign={"center"}>
            Market Insights
          </Typography>

          <PrintInsightsGrid>
            {insightsToDisplay.map((insight, index) => (
              <PrintInsightItem key={`insight-${index}`}>
                <Typography variant="body1" fontSize={20}>
                  {insight.content}
                </Typography>
                <Typography variant="body2" fontSize={16}>
                  {insight.footer}
                </Typography>
              </PrintInsightItem>
            ))}
          </PrintInsightsGrid>
        </PrintPage>
      </PrintPaper>
    </>
  );
};
